var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20.5 7h-17v10.71c0 .48.27.79.5.79h16c.23 0 .5-.31.5-.79V7zM4 4h16c1.1 0 2 1.02 2 2.29V17.7c0 1.27-.9 2.29-2 2.29H4c-1.1 0-2-1.02-2-2.29V6.3C2 5.02 2.9 4 4 4zm8.5 10.86a3.5 3.5 0 0 0-1-6.86h-3a3.5 3.5 0 0 0-.5 6.96v-1.39a2.14 2.14 0 0 1 .54-4.21h2.92a2.14 2.14 0 0 1 1.04 4.01v1.49zM16 10a3.5 3.5 0 0 1-.5 6.96h-3a3.5 3.5 0 0 1-1-6.85v1.45a2.16 2.16 0 0 0 1.03 4.06h2.94a2.16 2.16 0 0 0 .53-4.25V10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.3c0526a12e14d44a5aec47c1a82e73fd.svg";
export { ForwardRef as ReactComponent };